import { ReactNode } from 'react';
import React from 'react';
import Zone from "../../../pages/GeoNonGeo/Geo";
import HealthDivision from '@pages/GeoNonGeo/NonGeo';
import VhndUhnd from '@pages/GeoNonGeo/vhnduhnd/vhndUhnd';
interface TabsData {
  [key: string]: ReactNode;
}
export const tabsData :TabsData ={
    'Zone/Division/Circle':<Zone/>,
    'VHND/UHND Outreach':<VhndUhnd/>,
    'Health Block /Sub Division':<HealthDivision/>
}